import Rellax from "rellax";

export const parallax = {
  mounted() {
    this.$nextTick(() => {
      Object.entries(this.$refs).forEach(this.setParallax);
    });
  },
  methods: {
    setParallax([name, el]) {
      const speed = this.speeds[name];
      if (speed) {
        new Rellax(el, { speed, center: true });
      }
    }
  }
};
